

import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { submitGcaApproveRejectApplication, submitGcaEnclosureFiles } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import CommonSelect from "./CommonSelect";
import { toast,ToastContainer } from "react-toastify";
import { Option } from "./commonselectTow";
import { getAllAPMC } from "../../auth/services/apiCalling";


interface RectificationProp {
  rejectedDocs: any[];
  rejectedFields: Record<string, any>;
  applicationId: string;
  token: string;
  buttonData: any[];
  fetchApplicationDetails: (appId: any) => Promise<void>;
  applicationTransaction:any[];

  // fetchApplicationDetails:() => Promise<void>;
}

const RectificationOnResjection: React.FC<RectificationProp> = ({ rejectedDocs , rejectedFields , applicationId , token ,buttonData,fetchApplicationDetails , applicationTransaction})=> {


  const [formData, setFormData] = useState<{ [key: string]: any }>({});
  const [files, setFiles] = useState<{ [key: string]: File | null }>({});
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [fieldErrors, setFieldErrors] = useState<{ [key: string]: string }>({});
  const [uploading, setUploading] = useState<{ [key: string]: boolean }>({});
  const [comment , setComment] = useState<string>("");
  const [status , setStatus] = useState<string>("");
  const language = useSelector((state:any)=>state.auth.language);
  const [appStatusLevel , setAppStatusLevel] = useState<string>("");
  const [guarantorNo , setGuarantorNo] = useState<string>("");
  const [guarantorDetail_1, setguarantorDetail_1] = useState<{ [key: string]: any | null }>({});
  const [guarantorDetail_2, setguarantorDetail_2] = useState<{ [key: string]: any | null }>({});
  const [validationErrors, setValidationErrors] = useState<{ [key: string]: string }>({});
  const [fileValidationErrors, setFileValidationErrors] = useState<{ [key: string]: string }>({});
  const [guarantorDetails, setGuarantorDetails] = useState({});
  const [talukaOptionsCurr , setTalukaOptionsCurr] = useState<Option[]>([]);
 
  const [talukaOptionsPer , setTalukaOptionsPer] = useState<Option[]>([]);
  const [districtOptions , setDistrictOptions] = useState<Option[]>([]);
  const [talukaOptionsReg , setTalukaOptionsReg] = useState<Option[]>([]);

  const [resubmittedData, setResubmittedData] = useState<Array<{ [key: string]: any | null }>>([]);
  const formLanguage = useSelector((state:any)=>state.auth.formLanguage);
  const [reviews , setReviews] = useState<any[]>([])
  const [isSubmitting, setIsSubmitting] = useState(false);


  const uploadedDoc:any[] = [];
   const docOptions = [
    { value: "tarderPhoto", label: "Agent Photo" },
    { value: "solvencyCertificate", label: "Solvency Certificate" },
    { value: "bankGuarntee", label: "Bank Guarntee" },
    { value: "bankBalanceCertificate", label: "Bank Balance Certificate" },
    { value: "panCard", label: "Pan Card Number" },
    { value: "itReturns_1", label: "IT Returns 1" },
    { value: "itReturns_2", label: "IT Returns 2" },
    { value: "itReturns_3", label: "IT Returns 3" },
    { value: "electionCard", label: "Election Card" },
    { value: "chalanPayementLiceneseFeeDoc", label: "Challan (in support of payment of license fees)" },
    { value: "proofOfBusinessPalace", label: "Proof of Place of Business" },
    { value: "partnerShipDeed", label: "Partnership Deed" },
    { value: "companyArticleAssociation", label: "Article of Association" },
    { value: "companyAttorneyAuthorization", label: "Power of Attorney of Authorized Person" },
    { value: "coOpSocietyRegCertificate", label: "Co-operative Society Registration Certificate" },
    { value: "coOpSocietyByLaws", label: "Co-operative Society Bye-Laws" },
    { value: "coOpSocietyResObtLic", label: "Co-operative Society Resolution for Obtaining License" },
    { value: "coOpSocietyAuditReport", label: "Co-operative Society of Last Audit Report" },
    { value: "coOpSocietyIncomeExpenditure", label: "Co-operative Society Income-Expenditure Statement" },
    { value: "coOpSocietyBalanceSheetThreeYear", label: "Co-operative Society Balance Sheet for Last Three Years" },
    { value: "affidavit", label: "Proof of Probable Place Of Business and Market Committee" },
    { value: "enclousreDeclaration", label: "Enclosure Declaration" },
    { value: "declaration", label: "Declaration" },
    { value: "agentSignature", label: "Agent Signature" },
    { value: "guarantorDeclaration", label: "Guarantor Declaration" },
    { value: "license", label: "License" },
    { value: "otherDoc", label: "Additional other Document" },
{ value: "gstCertificateDocs", label: "GST Certificate" }
  ];
const accountTypes = [
  { value: "Savings", label: "Savings" },
  { value: "Current", label: "Current" },
  { value: "Fixed Deposit", label: "Fixed Deposit" },]
  const fieldsOptions =  [
    { value: "applicantName", label: "Applicant Name" },
    { value: "currAddress", label: "Current Address" },
    { value: "perAddress", label: "Permanent Address" },
    { value: "regOffAddress", label: "Registered Office Address" },
    { value: "panCardNo", label: "Pan Card Number" },
    { value: "electionCardNo", label: "Election Card Number" },
    { value: "regEmailId", label: "Registered Email ID" },
    { value: "mobileNo", label: "Mobile Number" },
    { value: "isFirm", label: "Is Firm" },
    { value: "entityName", label: "Entity Name" },
    { value: "entityType", label: "Entity Type" },
    { value: "entityRegistrationNo", label: "Entity Registration Number" },
    { value: "entityGstNo", label: "Entity GST Number" },
    { value: "entityPanNo", label: "Entity PAN Number" },
    { value: "entityFpoNo", label: "Entity FPO Number" },
    { value: "dob", label: "DOB" },
    { value: "yrOfExpAsBusErr", label: "Year of Experience as Business Engineer" },
    { value: "experienceDetail", label: "Experince Details" },
    { value: "govSemiGovExpDetail", label: "Work Performed Details" },
    { value: "marketPublicConstructionDetail", label: "Construction Done Details" },
    { value: "guarantorDetail_1", label: "Guarantor 1 Details " },
    { value: "guarantorDetail_2", label: "Guarantor 2 Details" },
     { value: "bankDetails", label: "Bank Details" },
  ];

  const fieldValidationRules: { [key: string]: any } = {
    applicantName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Applicant Name must contain only letters")
    .max(50, "Applicant Name cannot exceed 50 characters")
    .required("Applicant Name is required"),
    currAddress: Yup.string().required("Current Address is required"),
    perAddress: Yup.string().required("Permanent Address is required"),
    regOffAddress: Yup.string().required("Registered Office Address is required"),
    panCardNo: Yup.string()
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN Card Number format")
      .required("PAN Card Number is required"),
    electionCardNo: Yup.string().required("Election Card Number is required"),
    regEmailId: Yup.string()
      .email("Invalid email format")
      .required("Registered Email ID is required"),
    mobileNo: Yup.string()
      .matches(/^[6-9]\d{9}$/, "Invalid mobile number format")
      .required("Mobile Number is required"),
    isFirm: Yup.boolean().required("Firm status is required"),
    entityName: Yup.string().required("Entity Name is required"),
    entityType: Yup.string().required("Entity Type is required"),
    entityRegistrationNo: Yup.string().required("Entity Registration Number is required"),
    entityGstNo: Yup.string()
      .matches(/^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/, "Invalid GST Number format")
      .required("Entity GST Number is required"),
    entityPanNo: Yup.string()
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid Entity PAN Number format")
      .required("Entity PAN Number is required"),
    entityFpoNo: Yup.string().required("Entity FPO Number is required"),
  };

  const entityOptions = [
    { value: "Ind", label: "Individual" },
    { value: "Firm", label: "Firm" },
    { value: "Company", label: "Company" },
    { value: "CoSciety", label: "Cooperative Society" },
    { value: "Fpo", label: "Farmer Producer Organization (FPO)" },
    { value: "govEnt", label: "Government Entity" },
    { value: "Ngo", label: "Non-Governmental Organization (NGO)" },
    { value: "partnerFirm", label: "Partnership Firm" },
    { value: "Llp", label: "Limited Liability Partnership (LLP)" },
    { value: "Trust", label: "Trust" },
    { value: "Jv", label: "Joint Venture" },
  ];

  const firmOption =[
    { value: "true", label: "Yes" },
    { value: "false", label: "No" },

  ]
   const fetchAllDistrictTaluka = async (token: string , district?:string , taluka?:string , toUpdateDistOpt?:string): Promise<Option[]> => {
       
        try {
       
          let dist;
          let tal;
          if(district || taluka)
          {
         
            dist = district;
            tal = taluka;
          }
        
    
    
        
    
          const response = await getAllAPMC(token , dist , tal);
       
    
       if (dist && !tal) {
            // Step 2: Load Talukas
            
            const talukas = response.data.map((t) => ({
              label: t.Taluka,
              value: t.Taluka,
            }));
    
    
    
            if(toUpdateDistOpt == "currAddress")
            {
             
              setTalukaOptionsCurr(talukas)
    
            }
    
            if(toUpdateDistOpt == "perAddress")
              setTalukaOptionsPer(talukas)
    
            if(toUpdateDistOpt == "regOffAddress")
              setTalukaOptionsReg(talukas)
    
    
       
        
    
          } 
    
        } catch (error) {
          //.error('Error fetching APMC data:', error);
          return [];
        }
      };
  const fetchDistrict =async()=>{
    try {
      const response = await getAllAPMC(token , '' , '');
    

      const districts = response.data.map((d) => ({
        label: d.District,
        value: d.district_id,
      }));

      setDistrictOptions(districts);

    } catch (error) {
      toast.error('Internal Server Error')
    }
  }
   useEffect(()=>{
      fetchDistrict();
  },[])

    const toastCooldown = useRef(false);
  
    const showErrorToast = (message: string) => {
      if (toastCooldown.current) return; // Skip if still in cooldown
    
      toast.error(message );
      toastCooldown.current = true;
    
      // Reset cooldown after 3 seconds
      setTimeout(() => {
        toastCooldown.current = false;
      }, 3000);
    };

    const showSuccessToast = (message: string) => {
      if (toastCooldown.current) return; // Skip if still in cooldown
    
      toast.success(message);
      toastCooldown.current = true;
    
      // Reset cooldown after 3 seconds
      setTimeout(() => {
        toastCooldown.current = false;
      }, 3000);
    };

    const handleSelectChange = (name: string, option: any) => {
     
  
     
      setFormData({ ...formData, [name]: option ? option.value : "" });
    };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>,indx:any) => {
  
    if(indx == 0){
      setguarantorDetail_1((prev)=>({...prev,[e.target.name]: e.target.value}))
    
    }else if(indx == 1){
      setguarantorDetail_2((prev)=>({...prev,[e.target.name]: e.target.value}))
    }else{
    setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    
  };

  const handleInputOthers = (e: React.ChangeEvent<HTMLInputElement>) => {
    
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
 
  const handleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
    field: any // assuming `field` is an object with `documentName`
  ) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
  
  
  
      const existingDoc = resubmittedData.find(
        (item) => item.documentName === field.documentName
      );
  
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("documentName", field.documentName);
      formData.append("applicationId", applicationId);
  
      const res = await submitGcaEnclosureFiles(formData, token);
      if(res.success)
      {
        showSuccessToast(res?.message)
      }
      const newObj = {
        documentName: res?.data?.documentName,
        docId: res?.data?.id,
        fileName: res?.data?.fileName,
      };
  
      setResubmittedData((prev) => {
        const index = prev.findIndex((item) => item.documentName === newObj.documentName);
        if (index !== -1) {
          const updated = [...prev];
          updated[index] = newObj;
          return updated;
        }
        return [...prev, newObj];
      });
    }
  };

const handleGuarantorChange = async (e, docName = null, indexProp = null) => {
  const { name, type, files, value } = e.target;

  const documentName = docName || name;

  // Extract index from param or from document name like "guarantorPanCard_2"
  let index = indexProp;
 
  if (index === null) {
    const match = documentName.match(/_(\d+)$/);
    if (!match) {
    
      return;
    }
    index = match[1];
  }

  const key = `guarantor_${index}`;

  // Handle file input
  if (type === "file" && files && files[0]) {
    const file = files[0];

    const previousDocId =
      guarantorDetails[key]?.docDetail?.find((doc) => doc.documentName === documentName)?.docId || null;

     
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("documentName", documentName);
      formData.append("applicationId", applicationId);


      const res = await submitGcaEnclosureFiles(formData, token, previousDocId);

      if(res.success)
      {
         showSuccessToast(res?.message);
         const uploadedDoc = {
        documentName: res?.data?.documentName,
        docId: res?.data?.id,
        fileName: res?.data?.fileName,
      };

      setGuarantorDetails((prev) => {
        const prevDocList = prev[key]?.docDetail || [];

        const updatedDocs = prevDocList.some((doc) => doc.documentName === uploadedDoc.documentName)
          ? prevDocList.map((doc) =>
              doc.documentName === uploadedDoc.documentName ? uploadedDoc : doc
            )
          : [...prevDocList, uploadedDoc];

        return {
          ...prev,
          [key]: {
            ...prev[key],
            docDetail: updatedDocs,
          },
        };
      });
      }

     


    } catch (error) {
    
    }
  }

  // Handle text input
  else if(type === "text") {
    setGuarantorDetails((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [name]: value,
      },
    }));
  }
};

useEffect(()=>{
  
},[guarantorDetails])
  

  
    const convertFormData = (data: Record<string, any>) => {
      const result: Record<string, any> = {};
    
      for (const key in data) {
        // Handle array-based keys like: perAddress-0-at, experienceDetail-1-startDate
        const parts = key.split('-');
    
        if (parts.length === 3) {
          const [prefix, indexStr, field] = parts;
          const index = parseInt(indexStr);
    
          if (!result[prefix]) {
            result[prefix] = [];
          }
    
          if (!result[prefix][index]) {
            result[prefix][index] = {};
          }
    
          result[prefix][index][field] = data[key];
        } 
        // For other flat keys
        else {
          result[key] = data[key];
        }
      }
    
      return result;
    };


 const validateFields = () => {
      const errors: Record<string, string> = {};
      const specialCharRegex = /[^a-zA-Z0-9 ]/;
      const emailRegex = /^\S+@\S+\.\S+$/;
      const mobileRegex = /^[0-9]{10}$/;
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      const numericRegex = /^[0-9]+$/;
      const minDate = new Date();
      minDate.setFullYear(minDate.getFullYear() - 18);
      const minexp = 4;
    
   
    
      const rejectedFieldsArray = Object.keys(rejectedFields);
    
      rejectedFieldsArray.forEach((key) => {
        let value = rejectedFields[key];
   

        // Handle known multi-entry document fields
        if (
          [
            "experienceDoc_1", "experienceDoc_2", "experienceDoc_3",
            "workPerformanceDoc_1", "workPerformanceDoc_2", "workPerformanceDoc_3",
            "constructionDocs_1", "constructionDocs_2", "constructionDocs_3"
          ].includes(key)
        ) {
          value = Array.isArray(value) ? value : [value];
          value.forEach((_, index) => {
            const projectName = formData[`${key}-projectName`]?.trim();
            const startDateStr = formData[`${key}-startDate`];
            const endDateStr = formData[`${key}-endDate`];
    
            const today = new Date();
            const startDate = startDateStr ? new Date(startDateStr) : null;
            const endDate = endDateStr ? new Date(endDateStr) : null;
    
            if (!projectName) {
              errors[`${key}-projectName`] = "Project Name is required.";
            } else if (specialCharRegex.test(projectName)) {
              errors[`${key}-projectName`] = "No special characters allowed.";
            }
    
            if (!startDateStr) {
              errors[`${key}-startDate`] = "Start Date is required.";
            } else if (startDate && startDate > today) {
              errors[`${key}-startDate`] = "Start Date cannot be in the future.";
            }
    
            if (!endDateStr) {
              errors[`${key}-endDate`] = "End Date is required.";
            } else if (endDate && endDate > today) {
              errors[`${key}-endDate`] = "End Date cannot be in the future.";
            }
    
            if (startDate && endDate) {
              if (startDate > endDate) {
                errors[`${key}-startDate`] = "Start Date cannot be after End Date.";
                errors[`${key}-endDate`] = "End Date cannot be before Start Date.";
              }
            }
    
            // if (!formData[`${key}-evidenceProof`]) {
            //   errors[`${key}-evidenceProof`] = "File is required.";
            // }
          });
        }
    
        // Handle nested object fields
        else if (typeof value === "object" && value !== null && key!= "guarantorDetails") {
         
          if (Array.isArray(value)) {
            // Handle array of objects (e.g., perAddress, currAddress)
            value.forEach((item, index) => {
              if (typeof item === "object" && item !== null) {
                Object.keys(item).forEach((nestedKey) => {
                  const fieldKey = `${key}-${index}-${nestedKey}`;
                  const fieldValue = formData[fieldKey];
                 
                  if (!fieldValue || (typeof fieldValue === "string" && fieldValue.trim() === "")) {
                    errors[fieldKey] = `${language[nestedKey]} is required.`;
                  } 
                  // else if (specialCharRegex.test(fieldValue)) {
                  //   errors[fieldKey] = "No special characters allowed.";
                  // }
                  else if(nestedKey=="ifsc_code")
                  {
                    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
                    if (!ifscRegex.test(fieldValue)) {
                      errors[fieldKey] = "Invalid IFSC code format.Letters should be uppercase(e.g., SBIN0000691).";
                    }
                  }
                  else if(nestedKey=="acct_no")
                    {
                      const acctNoRegex = /^[0-9]{9,18}$/;
                      if (!acctNoRegex.test(fieldValue)) {
                        errors[fieldKey] = "Invalid Account Number format.";
                      }
                    }
                });
              }
            });
          } else {
            // Handle normal nested object
        
            Object.keys(value).forEach((nestedKey) => {
              const compoundKey = `${key}-${nestedKey}`;
              const nestedValue = formData[compoundKey];
        
              if (!nestedValue || (typeof nestedValue === "string" && nestedValue.trim() === "")) {
                errors[compoundKey] = `${language[nestedKey]} is required.`;
              } 
              else if (specialCharRegex.test(nestedValue) && key !== "dob") {
                errors[compoundKey] = "No special characters allowed.";
              }
            });
          }
        }
        
    
        // Handle normal fields
        else if( key!= "guarantorDetails")  {
          const fieldValue = formData[key]?.trim?.() || "";
    
          if (!fieldValue) {
            errors[key] = "This field is required.";
          } else if (key === "yrOfExpAsBusErr") {
            if (!numericRegex.test(fieldValue)) {
              errors[key] = "Only numeric values allowed.";
            } else if (parseFloat(fieldValue) < minexp) {
              errors[key] = `Minimum ${minexp} years of experience required.`;
            }
          } else if (key === "regEmailId" && !emailRegex.test(fieldValue)) {
            errors[key] = "Enter a valid email address.";
          } else if (key === "mobileNo" && !mobileRegex.test(fieldValue)) {
            errors[key] = "Mobile No. is not valid.";
          } else if (key === "panCardNo" && !panRegex.test(fieldValue)) {
            errors[key] = "Enter valid PAN number.";
          } else if (key === "dob") {
            const enteredDate = new Date(fieldValue);
            if (isNaN(enteredDate.getTime())) {
              errors[key] = "Invalid date format.";
            } else if (enteredDate > minDate) {
              errors[key] = `You must be at least 18 years old.`;
            }
          }
           else if (specialCharRegex.test(fieldValue) && key !== "dob" && key !== "regEmailId" &&key!=="partnerAddress") {
            errors[key] = "No special characters allowed.";
          }
        }
      });
    
      
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        ...errors,
      }));
    
      return Object.keys(errors).length === 0;
    };

  const validateGuarantorFields = () => {
  const errors = {};

  if (rejectedFields.guarantorDetails && Array.isArray(rejectedFields.guarantorDetails)) {
    rejectedFields.guarantorDetails.forEach((guarantor) => {
      const firstDoc = guarantor.docDetail?.[0];
      const match = firstDoc?.documentName?.match(/_(\d+)$/);
      const index = match ? match[1] : "0";
      const key = `guarantor_${index}`;
      const currentGuarantor = guarantorDetails[key] || {};

      // ✅ Text field validation
      ["name", "address", "panCardNo"].forEach((field) => {
        if (!currentGuarantor[field] || currentGuarantor[field].trim() === "") {
          errors[`guarantorDetails-${index}-${field}`] = `${language[field]} is required`;
        }
      });

      // ✅ File input validation
      (guarantor.docDetail || []).forEach((doc) => {
        const fileExists = currentGuarantor.docDetail?.some(
          (d) => d.documentName === doc.documentName
        );

        if (!fileExists) {
          errors[`guarantorDetails-${index}-${doc.documentName}`] = `${language[doc.documentName]} is required`;
        }
      });
    });
  }

  setFieldErrors(errors);
  return Object.keys(errors).length === 0;
};
    
    
    const handleObjectChange = (e, arrayKey = null, index = null,fieldKey?:any,key?:any) => {

      const { name, value } = e.target;
    
      if (arrayKey !== null && index !== null) {
        // For array of objects like perAddress
        setFormData((prev) => {
          const updatedArray = [...(prev[arrayKey] || [])];
          const updatedObject = { ...updatedArray[index], [name]: value };
          updatedArray[index] = updatedObject;
          return {
            ...prev,
            [arrayKey]: updatedArray,
          };
        });
      }  else {
      
        // Default flat handling
        if(fieldKey==="district"){
            setFormData((prev) => ({
          ...prev,
          [name]: districtOptions.find((opt) => opt.value === value)?.label || '',
        }));
          fetchAllDistrictTaluka(token , value , '' , key);
        }else{
            setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
        }
      }
    };
    

  const handleSubmit = async (status: string, appStatusLevel: string) => {
    setIsSubmitting(true);
   
    let resubmittedFieldFinal = convertFormData(formData);
    

    let isDocValid=true;

    // Include guarantor details if present
    if (Object.keys(guarantorDetail_1)?.length > 0 && Object.keys(guarantorDetail_2)?.length == 0) {
      // formData['guarantorDetail_1'] = guarantorDetail_1;
      setFormData(prev => ({
        ...prev,
        guarantorsDetails: [guarantorDetail_1],
      }));

    }

    if ( Object.keys(guarantorDetail_1)?.length > 0  && Object.keys(guarantorDetail_2)?.length > 0) {
      // formData['guarantorDetail_2'] = guarantorDetail_2;
      setFormData(prev => ({
        ...prev,
        guarantorsDetails: [guarantorDetail_1, guarantorDetail_2],
      }));

    }
  
    // Get all rejected document names
    const rejectedDocNames = rejectedDocs.map(doc => doc.documentName);
  
    // Get uploaded document names
    const uploadedDocNames = resubmittedData.map(doc => doc.documentName);
  
    // Find any missing uploads
    const missingDocs = rejectedDocNames.filter(docName => !uploadedDocNames.includes(docName));
  
    // If any document is missing, show errors and prevent submission
    if (missingDocs.length > 0) {
      const newErrors: any = {};
      missingDocs.forEach(docName => {
        newErrors[docName] = "This document is required.";
      });
      setErrors(newErrors); // assuming you are tracking errors in state
      
      isDocValid=false;
      // return; // prevent submission
    }

       let isguarantorValid = true;
      if(rejectedFields?.guarantorDetails &&  Array.isArray(rejectedFields.guarantorDetails)) {
   

       isguarantorValid = validateGuarantorFields();

       if(isguarantorValid)
        resubmittedFieldFinal = {
        ...resubmittedFieldFinal,
        guarantorDetails: {...guarantorDetails}, 
      };

 
    }
  
    // Proceed with submission if validation passes
    const finalBody = {
      reSubmittedFields: resubmittedFieldFinal,
      comment: comment,
      reSubmittedDocs: resubmittedData,
      status: status,
      appStatusLevel: appStatusLevel,
      applicationId: applicationId,
      rejectedDocName: [],
      rejectedFieldName: [],
    };
  
    
  
  
    // const isValid = validateFields(formData);
    const isValid=validateFields();
    
 

    if (!isValid || !isDocValid || !isguarantorValid) {
      
      setIsSubmitting(false);
      return;
    }

  if(comment=='')
    {
      toast.error("Comment is required");
      setIsSubmitting(false);
      return;
    }
    // Minimum 10 word check
    if(comment.trim().split(/\s+/).length < 10) {
      toast.error("Comment must be at least 10 words");
      setIsSubmitting(false);
      return;
    }
      // setIsSubmitting(false);
  
    // Uncomment once you're ready to submit

    const submitData = await submitGcaApproveRejectApplication(finalBody, token);
    setIsSubmitting(false);

    if(submitData.success==true)
    {
      showSuccessToast("Form re-submitted  Sucessfully");
      fetchApplicationDetails(applicationId);
      
    }
    else{
      showErrorToast(submitData?.message);

    }
    // fetchApplicationDetails(applicationId);
  };

    useEffect(()=>{
    
    const trans = applicationTransaction.filter(data=>data.appStatusLevel == "pendingAtGcaResubmission" )

     const latestComment = trans.reduce((acc , curr)=>{
        return curr.createdAt > acc.createdAt ? curr: acc
    }).comment;
  
   const arrOfComment = [...latestComment.matchAll(/([\w]+):\s*(.*?)(?=,\s*\w+:|$)/g)].map(match => ({
  key: match[1].trim(),
  value: match[2].trim()
}));
  
    setReviews(arrOfComment)
    },[])


  return (
    <div className="tab-content custom-accordion-items">
      <div className="tab-pane active show" id="bottom-justified-tab1" role="tabpanel">
        <div className="accordion accordions-items-separate" id="accordionExample">
          <div className="accordion-item">
            <div className="accordion-header" id="headingOne">
              <div className="accordion-button">
                <div className="d-flex align-items-center flex-fill">
                  <h5 className=" text-danger fs-18">{language.reu_info}</h5>
                  <Link
                    to="#"
                    className="d-flex align-items-center collapsed collapse-arrow ms-auto"
                    data-bs-toggle="collapse"
                    data-bs-target="#primaryBorderOne"
                    aria-expanded="false"
                    aria-controls="primaryBorderOne"
                  >
                    <i className="ti ti-chevron-down fs-18" />
                  </Link>
                </div>
              </div>
            </div>
            <div
              id="primaryBorderOne"
              className="accordion-collapse collapse show border-top"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body mt-2">
                <div className="row border border-2 py-4 mb-4">
                <h4 className="mb-3 border border-bottom-2 p-2">Review By Department</h4>

                {reviews.map((item, index) => (
                    <div key={index} className="col-md-6 mb-2  border-end ">
                      <li className="list-group-item fs-16">
                        <strong>{language[item.key] || item.key}:</strong> {item.value}
                      </li>
                    </div>
                  ))}
                </div>
                <div >
                <div className="row">
                {/* Left Column: File Upload Fields */}
                <div className="col-md-6">
                  <h5 className="mb-3">{language.upload_doc}</h5>
                
                  {rejectedDocs.length > 0 &&
                    rejectedDocs.map((field,index) => (
                
                      <div className="mb-3" key={`${field.documentName}_${index}`}>
                        <label className="col-form-label">{ docOptions.find((doc) => doc.value === field?.documentName)?.label || field.documentName}</label>
                        <div className="input">
                        <input
                              type="file"
                              className="form-control"
                              name={`${field.documentName}_${index}`}
                              // value={guarantor?.name || ''}
                              onChange={(e) => handleFileChange(e,field)}
                              required
                            />
                        
                          {/* <label htmlFor={`${field}Input`} className="btn btn-success">
                            <i className="fa fa-upload" title="Upload"></i>
                          </label> */}
                        </div>
                        {/* {errors[field] && <small className="text-danger">{errors[field]}</small>} */}
                        {errors[field?.documentName] && (
                            <small className="text-danger">{errors[field?.documentName]}</small>
                          )}

                      </div>
                    ))}
                </div>

                {/* Right Column: Input Fields */}
                <div className="col-md-6">
                  <h5 className="mb-3">{language.re_info}</h5>
    
  
                           

                          {Object.keys(rejectedFields).map((key) => {
                    const value = rejectedFields[key];

                    if (key === "guarantorDetails" && Array.isArray(value)) {
                      return value.map((guarantor) => {
                        // 👇 Extract index from first document's name (e.g. guarantorPanCard_2 → 2)
                        const firstDoc = guarantor?.docDetail?.[0];
                        const match = firstDoc?.documentName?.match(/_(\d+)$/);
                        const dynamicIndex = match ? match[1] : "0";

                        return (
                          <div key={`guarantor-${dynamicIndex}`} className="mb-4 border p-3 rounded">
                            <h5 className="mb-3">Guarantor {parseInt(dynamicIndex) }</h5>

                            {Object.keys(guarantor).map((fieldKey) => {
                              const fieldValue = guarantor[fieldKey];

                              // File input
                              if (fieldKey === "docDetail" && Array.isArray(fieldValue)) {
                                return fieldValue.map((doc, docIndx) => (
                                  <div className="mb-3" key={`doc-${docIndx}`}>
                                    <label className="form-label">
                                      {language[doc.documentName] || doc.documentName}
                                    </label>
                                    <input
                                      type="file"
                                      className="form-control"
                                      name={doc.documentName}
                                      onChange={(e) =>
                                        handleGuarantorChange(e, doc.documentName, dynamicIndex)
                                      }
                                    />
                                    {fieldErrors[`guarantorDetails-${dynamicIndex}-${doc.documentName}`] && (
                                      <small className="text-danger">
                                        {fieldErrors[`guarantorDetails-${dynamicIndex}-${doc.documentName}`]}
                                      </small>
                                    )}
                                  </div>
                                ));
                              }

                              // Text input
                              return (
                              <div className="mb-3" key={`guarantorDetails-${dynamicIndex}-${fieldKey}`}>
                    <label className="form-label">{language[fieldKey] || fieldKey}</label>
                    <input
                      type="text"
                      className={`form-control ${
                        fieldErrors[`guarantorDetails-${dynamicIndex}-${fieldKey}`] ? "is-invalid" : ""
                      }`}
                      name={fieldKey}  // 👈 Keep just the actual field key (e.g., "name", "address")
                      value={guarantorDetails?.[`guarantor_${dynamicIndex}`]?.[fieldKey] || ""}
                      onChange={(e) => handleGuarantorChange(e, '', dynamicIndex)} // 👈 Pass index
                    />
                    {fieldErrors[`guarantorDetails-${dynamicIndex}-${fieldKey}`] && (
                      <div className="text-danger">
                        {fieldErrors[`guarantorDetails-${dynamicIndex}-${fieldKey}`]}
                      </div>
                    )}
                  </div>
                              );
                            })}
                          </div>
                        );
                      });
                    }
                     else if (
                              Array.isArray(value) &&
                              value.length > 0 &&
                              typeof value[0] === "object" &&
                              !Array.isArray(value[0])
                            ) {
                              // Handles arrays of objects like perAddress, tempAddress, etc.
                              return value.map((item, index) => (
                                <div key={`${key}-${index}`} className="mb-3 border rounded p-3 mb-4">
                                  <h5 className="mb-2">{formLanguage[key] || key} ({language[key]})</h5>
                                  {Object.keys(item).map((fieldKey) => (
                                    <div key={`${key}-${index}-${fieldKey}`} className="mb-3">
                                      <label className="form-label">
                                        {`${formLanguage[fieldKey] || fieldKey} (${language[fieldKey] || fieldKey})`}
                                      </label>
                                 {fieldKey === "acct_type" ? (
                                        <CommonSelect
                                          options={accountTypes}
                                          value={accountTypes.find(opt => opt.value === formData[`${key}-${index}-${fieldKey}`]) || null}
                                          onChange={option => handleObjectChange({
                                            target: {
                                              name: `${key}-${index}-${fieldKey}`,
                                              value: option ? option.value : ""
                                            }
                                          })}
                                        />
                                      ) : fieldKey === "district" ? (
                                        <CommonSelect
                                          options={[...districtOptions].sort((a, b) => a.label.localeCompare(b.label))}
                                          value={districtOptions.find(opt => opt.value === formData[`${key}-${index}-${fieldKey}`]) || null}
                                          onChange={option => handleObjectChange({
                                            target: {
                                              name: `${key}-${index}-${fieldKey}`,
                                              value: option ? option.value : ""
                                            }
                                          },null,null,fieldKey,key)}
                                        />
                                      ) :
                                       fieldKey === "taluka" ? (
  (() => {
    let options = [];

    if (key === "perAddress") {
      options = talukaOptionsPer;
    } else if (key === "currAddress") {
      options = talukaOptionsCurr;
    } else if (key === "regOffAddress") {
      options = talukaOptionsReg;
    }

    return (
      <CommonSelect
        options={[...options].sort((a, b) => a.label.localeCompare(b.label))}
        value={
          options.find(
            (opt) => opt.value === formData[`${key}-${index}-${fieldKey}`]
          ) || null
        }
        onChange={(option) =>
          handleObjectChange({
            target: {
              name: `${key}-${index}-${fieldKey}`,
              value: option ? option.value : "",
            },
          })
        }
      />
    );
  })()
)  : (
                                        <input
                                          type="text"
                                          className={`form-control ${fieldErrors[`${key}-${index}-${fieldKey}`] ? "is-invalid" : ""}`}
                                          name={`${key}-${index}-${fieldKey}`}
                                          value={formData[`${key}-${index}-${fieldKey}`] || ""}
                                          onChange={ handleObjectChange}
                                        />
                                      )}
                                      {fieldErrors[`${key}-${index}-${fieldKey}`] && (
                                          <div className="invalid-feedback">
                                            {fieldErrors[`${key}-${index}-${fieldKey}`]}
                                          </div>
                                        )}
                                    </div>
                                  ))}
                                </div>
                                
                              ));
                              
                            }
                            
else {
                              return (
                                <div key={key} className="mb-3">
                                  {(() => {
                                    const labelKey = fieldsOptions.find((doc) => doc.value === key)?.value;
                                    return (
                                      <h5>
                                        {`${formLanguage[labelKey]} (${language[labelKey]})`}
                                      </h5>
                                    );
                                  })()}
                            
                                  {key === "entityType" || key === "isFirm" ? (
                                    <CommonSelect
                                      options={key === "entityType" ? entityOptions : firmOption}
                                      value={
                                        (key === "entityType"
                                          ? entityOptions.find((opt) => opt.value === formData[key])
                                          : firmOption.find((opt) => opt.value === formData[key])) || null
                                      }
                                      onChange={(option) => handleSelectChange(key, option)}
                                    />
                                  ) : (
                                    <input
                                      type={key === "dob" ? "date" : "text"}
                                      className={`form-control ${fieldErrors[key] ? "is-invalid" : ""}`}
                                      name={key}
                                      value={formData[key] || ""}
                                      onChange={handleInputOthers}
                                      {...(key === "dob" ? { max: new Date().toISOString().split("T")[0] } : {})}
                                    />
                                  )}
                            
                                  {fieldErrors[key] && (
                                    <small className="text-danger">{fieldErrors[key]}</small>
                                  )}
                                </div>
                              );
                            }
                            

                  })}



                    </div>
                </div>
                  {  buttonData.length > 0  && 
                  <div className="row">
                    <textarea
                    className="form-control mb-3"
                    placeholder="Enter your comment (min 10 words)"
                    name="currAt"
                    value={comment!=""? comment : ""} // Bind value to state
                    onChange={(e) => setComment(e.target.value)} // Update state on type
                    rows={4} // Adjust number of rows as needed
                    required
                  />

                      <div className="d-flex gap-2">
                        {buttonData.map((button) => (
                          <button
                            key={button.status}
                            className="btn btn-success h-10 w-70"
                            onClick={() => handleSubmit(button.status , button.appStatusLevel)}
                            disabled={isSubmitting}
                          >
                            {button.buttonLabel}
                          </button>
                          
                        ))}
                        <ToastContainer position="top-center" autoClose={3000} />
                        
                      </div>

                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RectificationOnResjection;
